/**
 * Topic Responses component created by karora on 26/05/17.
 */
import { switchMap } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

import { AppComponent } from '../app.component';
import { ProfileService } from '../services/profile.service';
import { VoxPopService } from '../services/voxpop.service';
import { Topic } from '../types/topic';

@Component({
  selector: 'topic-responses',
  templateUrl: './topic-responses.component.html',
  styleUrls: ['./topic-responses.component.css'],
  providers: [],
  standalone: false
})


export class TopicResponsesComponent implements OnInit {
  errorMessage: any;
  showAll: boolean = false;
  topic: Topic;

  constructor(
    private voxPopService: VoxPopService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    if (!ProfileService.IsLoggedIn()) return;

    console.log("Getting topic detail.");
    this.route.params.pipe(switchMap((params: Params) => this.voxPopService.getTopic(+params['topicid'])))
      .subscribe(
        topic => this.setTopic(topic),
        error => this.errorMessage = <any>error,
      );
  }

  setTopic(topic: Topic) {
    console.log("Loaded topic " + topic.topic + "(" + topic.id + ")");
    this.topic = topic;
    AppComponent.SetTitle(topic.topic + ' (' + topic.id + ')')
  }

  toggleShowAll(): void {
    this.showAll = !this.showAll;
  }

}
